import { useState, useEffect } from 'react';
import { userQuotaAPI } from '../services/userQuotaAPI';
import { getQuotaStatus, getQuotaClasses } from '../config/appConfig';

export const useUserQuota = (user) => {
  const [userQuota, setUserQuota] = useState(null);
  const [quotaLoading, setQuotaLoading] = useState(true);

  // Cargar cuota del usuario
  useEffect(() => {
    const loadUserQuota = async () => {
      if (!user) {
        setUserQuota(null);
        setQuotaLoading(false);
        return;
      }

      setQuotaLoading(true);
      try {
        const quotaResult = await userQuotaAPI.getUserQuota();
        if (quotaResult.success) {
          setUserQuota(quotaResult.data);
        } else {
          setUserQuota(null);
        }
      } catch (error) {
        console.error('Error al cargar cuota:', error);
        setUserQuota(null);
      } finally {
        setQuotaLoading(false);
      }
    };

    loadUserQuota();
  }, [user]);

  // Calcular información de cuota para mostrar
  const quotaInfo = userQuota && !quotaLoading ? userQuotaAPI.formatQuotaInfo(userQuota) : null;
  
  // Obtener estado y clases de la cuota usando configuración centralizada
  const quotaStatus = userQuota ? getQuotaStatus(userQuota.available_documents) : null;
  const quotaClasses = userQuota ? getQuotaClasses(userQuota.available_documents) : null;

  return {
    userQuota,
    quotaLoading,
    quotaInfo,
    quotaStatus,
    quotaClasses
  };
};
